import React, { useState } from 'react'
import { Copy } from 'react-feather'

import { ContactUs } from '@frame/ui-components/contact-us'
import { Footer } from '@frame/ui-components/footer'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { Card } from '@frame/ui-primitives/card'
import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

import widgetError from '@frame/images/widget-error.svg'
import { ClientSessionState } from '@frame/lib/api/client-session/types'
import { InternalError } from '@frame/lib/errors'
import { events } from '@frame/lib/events'
import { useStore } from '@frame/lib/stores/useStore'
import { DataAttribute } from '@frame/types'

export function ErrorContent({ error }: { error?: InternalError }) {
  const { id, sessionState } = useStore((state) => {
    return {
      id: state?.session?.id,
      usePOSFlow:
        state.session && state.session.state === ClientSessionState.EMPLOYMENTS && state.session?.max_employments > 1,
      sessionState: state.session?.state,
    }
  })
  const [copied, setCopied] = useState(false)
  const [copyFailed, setCopyFailed] = useState(false)

  function handleCopy() {
    navigator.clipboard
      .writeText(`Error: ${error?.displayReason}; Session NIID: ${id}`)
      .then(() => {
        setCopyFailed(false)
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 1000)
      })
      .catch(() => {
        setCopyFailed(true)
      })
  }

  return (
    <>
      <Body data-cy={DataAttribute.SCREEN_ERROR} hasBackgroundColor={false} className="p-5">
        <img data-cy={DataAttribute.ERROR_IMAGE} className="mx-auto mb-3 max-w-[175px]" src={widgetError} />
        <H4 className="my-2">Oops we've hit a snag</H4>
        <ContactUs error={Boolean(error)} />
        {error ? (
          <Card intent="secondary" className="mt-4 w-full p-4">
            <H4 className="mb-1">{error?.displayMessage}</H4>
            <P className="mb-1">{error?.displayReason}</P>
            <Card border className="mt-2 break-words px-3 py-2 font-mono">
              <Span className="text-xs">{id}</Span>
              {sessionState ? <Span className="text-xs">-{sessionState}</Span> : null}
            </Card>
          </Card>
        ) : null}
      </Body>
      <Footer
        hasBackgroundColor={false}
        buttons={{
          primary: (
            <Button disabled={copyFailed} onClick={handleCopy} data-cy={DataAttribute.BTN_COPY_ERROR} Icon={Copy}>
              {copied ? 'Copied!' : 'Copy Error'}
            </Button>
          ),
          secondary: (
            <Button intent="secondary" onClick={() => events.emit('close')}>
              Close
            </Button>
          ),
        }}
      />
    </>
  )
}
